import { Buffer } from 'buffer';
import { P00039 } from './P00039';
import { DeviceTableIndex, IMasterSync, RxTxDescriptor } from '../IMasterSync';
import {
  IProduct,
  IProductDependance,
  ProductDependanceEnum,
} from '../IProduct';
import {
  getPoolMasterClass,
  getPoolProductsClass,
  getProductByModelIdentifier,
  isMaster,
} from '../../ECoSystemsHelper';
import { P00039InterfaceV3 } from './P00039/Interface/P00039InterfaceV3';
import { P00039InterfaceV4 } from './P00039/Interface/P00039InterfaceV4';
import { IDeviceTableNode } from '../IDeviceTable';
import { P00039InterfaceV5 } from './P00039/Interface/P00039InterfaceV5';
import { P00039InterfaceV6 } from './P00039/Interface/P00039InterfaceV6';
import { P00039InterfaceV7 } from './P00039/Interface/P00039InterfaceV7';
import { P00039InterfaceV9 } from './P00039/Interface/P00039InterfaceV9';
import { Pool } from '../../../../apis/pool.api';
import { P00039InterfaceV12 } from './P00039/Interface/P00039InterfaceV12';

export function P00039ProductDependance(
  productClass: IProduct,
  filter: ProductDependanceEnum | ProductDependanceEnum[] | null = null,
): IProductDependance[] {
  const modelIdentifierIndex = [
    'P00036-00',
    'P00047-00',
    'P00036-01',
    'P00046',
    'P00058',
    'P00066-00',
    'P00039',
    'P00031',
    'P00030',
    'P00032',
    'P00036-05',
    'P00048-00',
    'P00037-00',
    'P00036-07',
    'P00049',
    'P00036-06',
    'P00048-01',
    'P00043',
    'P00042',
    'P00041',
    'P00036-02',
    'P00047-02',
    'P00036-03',
    'P00047-03',
    'P00036-04',
    'P00047-04',
    'P00045',
    'P00061',
    'P00062',
    'P00080',
  ];

  //O : Pas de dependance , 1 : dependance, 2 : dependance notification, 9 : impossibilite
  const matrice = [
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00036-00
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00047-00
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00036-01
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00046
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00058
    [
      9, 9, 9, 9, 9, 9, 1, 1, 0, 0, 1, 1, 0, 1, 1, 0, 0, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00066-00
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00039
    [
      0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00031
    [
      1, 1, 1, 1, 1, 1, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00030
    [
      1, 1, 1, 1, 1, 1, 1, 1, 0, 9, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 0,
      0, 0, 0, 0, 0,
    ], //P00032
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 9,
    ], //P00036-05
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 9,
    ], //P00048-00
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00037-00
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00036-07
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00049
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 9,
    ], //P00036-06
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 9,
    ], //P00048-01
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 9, 9, 0,
    ], //P00043
    [
      0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00042
    [
      0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00041
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00036-02
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0,
      0, 0, 0, 0, 0,
    ], //P00047-02
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0,
      0, 0, 0, 0, 0,
    ], //P00036-03
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0,
      0, 0, 0, 0, 0,
    ], //P00047-03
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9,
      9, 0, 0, 0, 0,
    ], //P00036-04
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9,
      9, 0, 0, 0, 0,
    ], //P00047-04
    [
      2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2, 2,
      2, 9, 2, 2, 2,
    ], //P00045
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 9, 9, 0,
    ], //P00061
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 9, 9, 0,
    ], //P00062
    [
      0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0,
      0, 0, 0, 0, 9,
    ], //P00080
  ];

  const indexOfProduct = modelIdentifierIndex.indexOf(
    productClass.modelIdentifier!,
  );

  if (indexOfProduct === -1) {
    return [];
  }

  let res = [];

  for (let i = 0; i < matrice[indexOfProduct].length; i++) {
    if (modelIdentifierIndex[i] == productClass.modelIdentifier) {
      continue;
    }

    if (filter != null) {
      if (
        Array.isArray(filter) &&
        filter.indexOf(matrice[indexOfProduct][i]) >= 0
      ) {
        res.push({
          modelIdentifier: modelIdentifierIndex[i],
          level: matrice[indexOfProduct][i],
        });
      } else if (filter === matrice[indexOfProduct][i]) {
        res.push({
          modelIdentifier: modelIdentifierIndex[i],
          level: matrice[indexOfProduct][i],
        });
      }
    } else {
      res.push({
        modelIdentifier: modelIdentifierIndex[i],
        level: matrice[indexOfProduct][i],
      });
    }
  }

  return res;
}

export enum P00039DeviceTableRxTxIndex {
  System_Sync = 0,

  DeviceTable_P00039 = 1,
  DeviceTable_P0003600 = 2,
  DeviceTable_P0004700 = 3,
  DeviceTable_P0003601 = 4,
  DeviceTable_P00046 = 5,
  DeviceTable_P00031 = 6,
  DeviceTable_P00030 = 7,
  DeviceTable_P00032 = 8,
  DeviceTable_P0003605 = 9,
  DeviceTable_P0004800 = 10,
  DeviceTable_P0003700 = 11,
  DeviceTable_P0003607 = 12,
  DeviceTable_P00049 = 13,
  DeviceTable_P0003606 = 14,
  DeviceTable_P0004801 = 15,
  DeviceTable_P00043 = 16,
  DeviceTable_P00042 = 17,
  DeviceTable_P00041 = 18,
  DeviceTable_P0003602 = 19,
  DeviceTable_P0004702 = 20,
  DeviceTable_P0003603 = 21,
  DeviceTable_P0004703 = 22,
  DeviceTable_P0003604 = 23,
  DeviceTable_P0004704 = 24,
  DeviceTable_P00045 = 25,
  DeviceTable_P00061 = 26,
  DeviceTable_P00062 = 27,
  DeviceTable_P00058 = 28,
  DeviceTable_P0006600 = 29,
  DeviceTable_P00076 = 30,
  DeviceTable_P00080 = 31,
}

export enum P00039DataRxTxIndex {
  System_Sync = 0,

  Maitre_Parametrage = 1,
  Maitre_Installation = 2,

  Eclairage_Controle = 3,
  Eclairage_Parametrage = 4,
  Eclairage_Parametrage3 = 162,
  Eclairage_Parametrage4 = 163,
  Eclairage_Parametrage5 = 164,
  Eclairage_Parametrage6 = 165,
  Eclairage_Parametrage7 = 166,
  Eclairage_Installation = 5,
  Eclairage_Status = 6,

  ZB_Controle = 7,
  ZB_Status = 8,

  DeviceTable_Controle = 9,
  DeviceTable_Status = 10,

  FiltrationStandard_Controle = 11,
  FiltrationStandard_Parametrage = 12,
  FiltrationStandard_Parametrage2 = 13,
  FiltrationStandard_Installation = 14,
  FiltrationStandard_Status = 15,

  FiltrationVS_Controle = 16,
  FiltrationVS_Parametrage = 17,
  FiltrationVS_Parametrage2 = 18,
  FiltrationVS_Parametrage3 = 19,
  FiltrationVS_Parametrage4 = 20,
  FiltrationVS_Installation = 21,
  FiltrationVS_Status = 22,
  FiltrationVS_Status2 = 161,

  InjectionChlore_Controle = 23,
  InjectionChlore_Parametrage = 24,
  InjectionChlore_Installation = 25,
  InjectionChlore_Status = 26,

  InjectionPh_Controle = 27,
  InjectionPh_Parametrage = 28,
  InjectionPh_Installation = 29,
  InjectionPh_Status = 30,

  ElectrolyseurStandard_Controle = 31,
  ElectrolyseurStandard_Parametrage = 32,
  ElectrolyseurStandard_Installation = 33,
  ElectrolyseurStandard_Status = 34,

  NCC_Controle = 35,
  NCC_Parametrage = 36,
  NCC_Installation = 37,
  NCC_Status = 38,

  Robot_Controle = 39,
  Robot_Parametrage = 40,
  Robot_Installation = 41,
  Robot_Status = 42,

  Blower_Controle = 43,
  Blower_Parametrage = 44,
  Blower_Installation = 45,
  Blower_Status = 46,

  CouvertureManuelle_Installation = 47,
  CouvertureManuelle_Controle = 48,
  CouvertureManuelle_Status = 49,

  Volet230_Controle = 50,
  Volet230_Installation = 51,
  Volet230_Status = 52,
  Volet230_Parametrage = 83,

  Volet24_Controle = 53,
  Volet24_Installation = 54,
  Volet24_Status = 55,
  Volet24_Parametrage = 82,

  Connect_Status = 56,
  Connect_Installation = 57,
  Connect_Installation2 = 58,
  Connect_Installation3 = 59,
  Connect_Status2 = 84,
  Connect_Timezone = 106,

  Maitre_Status = 60,

  Sense_Status = 61,
  Sense_Controle = 62,
  Sense_Installation = 63,

  TunableStandard_Controle = 85,
  TunableStandard_Installation = 86,
  TunableStandard_Status = 87,
  TunableStandard_Parametrage1 = 88,
  TunableStandard_Parametrage2 = 89,
  TunableCouleur_Controle = 90,
  TunableCouleur_Parametrage1 = 91,
  TunableCouleur_Parametrage2 = 92,
  TunableCouleur_Parametrage3 = 93,
  TunableCouleur_Parametrage4 = 94,
  TunableCouleur_Parametrage5 = 95,
  TunableCouleur_Status = 96,
  TunableBlanc_Controle = 97,
  TunableBlanc_Parametrage1 = 98,
  TunableBlanc_Parametrage2 = 99,
  TunableBlanc_Parametrage3 = 100,
  TunableBlanc_Status = 101,
  Tunable_Installation = 102,
  Tunable_Status = 103,
  Tunable_Controle = 104,
  Tunable_Parametrage = 105,

  PAC_Control = 64,
  PAC_Parametrage = 65,
  PAC_Installation = 66,
  PAC_Status = 67,

  TAir_Installation = 68,
  TAir_Status = 69,

  Eclairage_Parametrage2 = 70,

  ZB_Controle2 = 71,
  ZB_Status2 = 72,

  FiltrationStandard_Parametrage3 = 73,
  FiltrationStandard_Status2 = 74,

  InjectionChlore_Status2 = 75,

  ElectrolyseurStandard_Parametrage2 = 76,
  ElectrolyseurStandard_Status2 = 77,

  PAC_Parametrage2 = 78,

  TAir_Controle = 79,

  Maitre_Settings = 80,
  Maitre_Maj = 81,

  PACWP_Controle = 107,
  PACWP_Installation = 108,
  PACWP_Parametrage1 = 109,
  PACWP_Parametrage2 = 110,
  PACWP_Parametrage3 = 111,
  PACWP_Parametrage4 = 112,
  PACWP_Parametrage5 = 113,
  PACWP_Parametrage6 = 114,
  PACWP_Parametrage7 = 115,
  PACWP_Parametrage8 = 116,
  PACWP_Parametrage9 = 117,
  PACWP_Status1 = 118,
  PACWP_Status2 = 119,

  SALT_Controle = 120,
  SALT_Parametrage1 = 121,
  SALT_Parametrage2 = 122,
  SALT_Parametrage3 = 123,
  SALT_Parametrage4 = 124,
  SALT_Parametrage5 = 125,
  SALT_Installation = 126,
  SALT_Status1 = 127,
  SALT_Status2 = 128,

  PACPOLY_Controle = 129,
  PACPOLY_Installation = 130,
  PACPOLY_Parametrage1 = 131,
  PACPOLY_Parametrage2 = 132,
  PACPOLY_Parametrage3 = 133,
  PACPOLY_Parametrage4 = 134,
  PACPOLY_Parametrage5 = 135,
  PACPOLY_Parametrage6 = 136,
  PACPOLY_Parametrage7 = 137,
  PACPOLY_Parametrage8 = 138,
  PACPOLY_Parametrage9 = 139,
  PACPOLY_Status1 = 140,

  PompeVS_Controle = 141,
  PompeVS_Installation = 142,
  PompeVS_Parametrage1 = 143,
  PompeVS_Parametrage2 = 144,
  PompeVS_Parametrage3 = 145,
  PompeVS_Parametrage4 = 146,
  PompeVS_Parametrage5 = 147,
  PompeVS_Parametrage6 = 148,
  PompeVS_Parametrage7 = 149,
  PompeVS_Parametrage8 = 150,
  PompeVS_Parametrage9 = 151,
  PompeVS_Parametrage10 = 152,
  PompeVS_Parametrage11 = 153,
  PompeVS_Parametrage12 = 154,
  PompeVS_Parametrage13 = 155,
  PompeVS_Parametrage14 = 156,
  PompeVS_Parametrage15 = 157,
  PompeVS_Parametrage16 = 158,
  PompeVS_Parametrage17 = 159,
  PompeVS_Status1 = 160,
  PompeVS_Status2 = 167,

  Constance_Control = 168,
  Constance_Installation = 169,
  Constance_Parametrage = 170,
  Constance_Status = 171,

  Altimeo_Status = 172,
  Altimeo_Control = 174,
  Altimeo_Installation = 173,
}

export class P00039Sync implements IMasterSync {
  version: number = 0;

  isSync: boolean = false;

  backup: any = {
    dt: {},
    data: {},
  };

  deviceTableRxtxSync: any[] = [];

  dataRxtxSync: any[] = [];

  productDeviceTableIndex: DeviceTableIndex[] = [];

  dataRxtxDescriptors: any = [];

  deviceTableRxtxDescriptors: any = [];

  constructor(version: number = 0) {
    this.version = version;

    if (this.version <= 3) {
      const n = new P00039InterfaceV3();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version === 4) {
      const n = new P00039InterfaceV4();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version === 5) {
      const n = new P00039InterfaceV5();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version === 6) {
      const n = new P00039InterfaceV6();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version === 7) {
      const n = new P00039InterfaceV7();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version === 8) {
      const n = new P00039InterfaceV7();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version < 12) {
      const n = new P00039InterfaceV9();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    } else if (version >= 12) {
      const n = new P00039InterfaceV12();
      this.productDeviceTableIndex = n.productDeviceTableIndex;
      this.dataRxtxDescriptors = n.dataRxtxDescriptors;
      this.deviceTableRxtxDescriptors = n.deviceTableRxtxDescriptors;
    }
    //Note : La dernier version connue doit toujours être >=, pour eviter de devoir déployer à nouveau l'application dans le cas d'une mise à jour du P00039 sans modification de l'interface
  }

  public productIsAllowed(modelIdentifier: string): boolean {
    for (let i = 0; i < this.productDeviceTableIndex.length; i++) {
      if (this.productDeviceTableIndex[i].modelIdentifier === modelIdentifier) {
        return true;
      }
    }
    return false;
  }

  addBackup(isDt: boolean, indexBuffer: string, dataBuffer: string): void {
    if (isDt) {
      this.backup.dt[indexBuffer] = dataBuffer;
    } else {
      this.backup.data[indexBuffer] = dataBuffer;
    }
  }

  getDeviceTableDescriptorByIndex(index: number): RxTxDescriptor | null {
    for (let i = 0; i < this.deviceTableRxtxDescriptors.length; i++) {
      if (this.deviceTableRxtxDescriptors[i].key === index) {
        return this.deviceTableRxtxDescriptors[i];
      }
    }

    return null;
  }

  hasProductToConfigure(pool: Pool): boolean {
    return this.getProductToConfigure(pool).length > 0;
  }

  hasProductToFinishDelete(pool: Pool): boolean {
    return this.getProductToFinishDelete(pool).length > 0;
  }

  getProductToFinishDelete(pool: Pool): IProduct[] {
    let productToFinish = [];
    let poolProductsClass = getPoolProductsClass(pool);
    const master = getPoolMasterClass(pool);

    const productIsImpossible = (productClass: IProduct, m: any, p: Pool) => {
      const impossibiliteTechno = P00039ProductDependance(
        productClass!,
        ProductDependanceEnum.IMPOSSIBLE,
      );

      for (let k = 0; k < impossibiliteTechno.length; k++) {
        const pC = getProductByModelIdentifier(
          impossibiliteTechno[k].modelIdentifier,
        );
        const presenceProduit = m?.hasProduct(p, pC) ?? 0;
        if (presenceProduit) {
          return true;
        }
      }

      return false;
    };

    for (let i = 0; i < poolProductsClass.length; i++) {
      const presenceProduit =
        master?.hasProduct(pool, poolProductsClass[i]) ?? 0;

      if (
        presenceProduit === 0 &&
        productIsImpossible(poolProductsClass[i], master, pool) === false &&
        poolProductsClass[i].needConfiguration &&
        poolProductsClass[i].needConfiguration(pool) === false
      ) {
        productToFinish.push(poolProductsClass[i]);
      }
    }

    return productToFinish;
  }

  getProductToConfigure(pool: Pool): IProduct[] {
    let productToConfigure = [];
    let poolProductsClass = getPoolProductsClass(pool);
    const master = getPoolMasterClass(pool);

    for (let i = 0; i < poolProductsClass.length; i++) {
      const presenceProduit =
        master?.hasProduct(pool, poolProductsClass[i]) ?? 0;

      if (
        isMaster(poolProductsClass[i]) &&
        poolProductsClass[i].needConfiguration &&
        poolProductsClass[i].needConfiguration(pool)
      ) {
        productToConfigure.push(poolProductsClass[i]);
      } else if (
        presenceProduit > 0 &&
        poolProductsClass[i].needConfiguration &&
        poolProductsClass[i].needConfiguration(pool)
      ) {
        productToConfigure.push(poolProductsClass[i]);
      }
    }

    return productToConfigure;
  }

  getDataDescriptorByIndex(index: number): RxTxDescriptor | null {
    for (let i = 0; i < this.dataRxtxDescriptors.length; i++) {
      if (this.dataRxtxDescriptors[i].key === index) {
        return this.dataRxtxDescriptors[i];
      }
    }

    return null;
  }

  getDeviceTableSyncIndex(): number {
    return P00039DeviceTableRxTxIndex.System_Sync;
  }

  getDataForLang(lang: string): Buffer {
    const buffer = Buffer.allocUnsafe(3);
    buffer.writeUInt16LE(P00039DataRxTxIndex.Maitre_Parametrage, 0);

    if (lang === 'fr') {
      buffer.writeUInt8(0, 2);
    } else {
      buffer.writeUInt8(1, 2);
    }

    return buffer;
  }

  getDataSyncIndex(): number {
    return P00039DataRxTxIndex.System_Sync;
  }

  getSyncMode(
    pool: Pool,
    deviceTable: boolean = true,
    datas: boolean = true,
  ): number {
    const data = pool.deviceTable.master;

    if (deviceTable && datas) {
      return data.deviceTable.syncMode || data.data.syncMode;
    } else if (deviceTable) {
      return data.deviceTable.syncMode;
    }

    return data.data.syncMode;
  }

  initSyncMode(pool: Pool): Pool {
    pool.deviceTable.master = {
      ...new P00039(),
      ...pool.deviceTable.master,
    } as P00039;

    pool.deviceTable.master.deviceTable = {};
    for (let i = 0; i < this.productDeviceTableIndex.length; i++) {
      pool.deviceTable.master.deviceTable[
        this.productDeviceTableIndex[i].modelIdentifier.replace('-', '')
      ] = new IDeviceTableNode(0);
    }

    Object.keys(pool.deviceTable.master.deviceTable).forEach((key) => {
      let p = getProductByModelIdentifier(key, true);

      if (p && !isMaster(p)) {
        pool.deviceTable[p!.dataIdentifier!] = {
          ...p,
          ...pool.deviceTable[p!.dataIdentifier!],
        };
      }
    });

    //on va appliquer le backup si il existe
    if (pool.backup) {
      const backupJson = JSON.parse(pool.backup);

      Object.keys(backupJson.dt).forEach((key) => {
        try {
          const value = backupJson.dt[key];
          const index = Buffer.from(key, 'hex').readInt16LE(0);
          const buffer = Buffer.from(value.toString(), 'hex');
          const descriptor = this.getDeviceTableDescriptorByIndex(index);

          if (descriptor) {
            const paddingBuffer = Buffer.alloc(100);
            const safeBuffer = Buffer.concat([buffer, paddingBuffer], 100);

            if (descriptor!.notify) {
              descriptor!.notify(pool!, index, safeBuffer);
            }
          }
        } catch (e) {
          console.log(e);
        }
      });

      Object.keys(backupJson.data).forEach((key) => {
        try {
          const value = backupJson.data[key];
          const index = Buffer.from(key, 'hex').readInt16LE(0);
          const buffer = Buffer.from(value.toString(), 'hex');
          const descriptor = this.getDataDescriptorByIndex(index);

          if (descriptor) {
            const paddingBuffer = Buffer.alloc(100);
            const safeBuffer = Buffer.concat([buffer, paddingBuffer], 100);

            if (descriptor!.notify) {
              descriptor!.notify(pool!, index, safeBuffer);
            }
          }
        } catch (e) {
          console.log(e);
        }
      });
    }

    this.backup.dt = {};
    this.backup.data = {};

    const data = pool.deviceTable.master;
    data.deviceTable.syncMode = 1;
    data.data.syncMode = 1;
    return pool;
  }

  deviceTableMarkAsSync(index: number) {
    if (this.deviceTableRxtxSync.indexOf(index) !== -1) {
      return;
    }

    this.deviceTableRxtxSync.push(index);
    this.isSync =
      this.dataRxtxDescriptors.length <= this.dataRxtxSync.length &&
      this.deviceTableRxtxDescriptors.length <= this.deviceTableRxtxSync.length;
  }

  dataMarkAsSync(index: number) {
    if (this.dataRxtxSync.indexOf(index) !== -1) {
      return;
    }

    this.dataRxtxSync.push(index);
    this.isSync =
      this.dataRxtxDescriptors.length <= this.dataRxtxSync.length &&
      this.deviceTableRxtxDescriptors.length <= this.deviceTableRxtxSync.length;
  }

  deviceTableNotSyncDescriptors(): RxTxDescriptor[] {
    let r: RxTxDescriptor[] = [];

    for (let i = 0; i < this.deviceTableRxtxDescriptors.length; i++) {
      if (
        this.deviceTableRxtxSync.indexOf(
          this.deviceTableRxtxDescriptors[i].key,
        ) === -1
      ) {
        r.push(this.deviceTableRxtxDescriptors[i]);
      }
    }

    return r;
  }

  dataNotSyncDescriptors(): RxTxDescriptor[] {
    let r: RxTxDescriptor[] = [];

    for (let i = 0; i < this.dataRxtxDescriptors.length; i++) {
      if (this.dataRxtxSync.indexOf(this.dataRxtxDescriptors[i].key) === -1) {
        r.push(this.dataRxtxDescriptors[i]);
      }
    }

    return r;
  }

  resetSync(): void {
    this.dataRxtxSync = [];
    this.deviceTableRxtxSync = [];
    this.isSync = false;
  }

  getTotalDataVector(): number {
    let max = 0;

    for (let i = 0; i < this.dataRxtxDescriptors.length; i++) {
      if (max < this.dataRxtxDescriptors[i].key) {
        max = this.dataRxtxDescriptors[i].key;
      }
    }

    return max;
  }
}
